import wx from 'weixin-js-sdk'
import { getJsAPI } from '@/apis/weixin'
export default {
    //拍照
    getLocalImgData() {
        return new Promise((resolve) => {
            let params = {
                url: window.location.href
            }
            getJsAPI(params).then((res) => {
                let data = res.data
                wx.config({
                    debug: false, // 开启调试模式
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature, // 必填，签名，见附录1
                    jsApiList: ['checkJsApi', 'getLocation', 'openLocation', 'chooseImage', 'getLocalImgData'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
                });
                wx.ready(function () {
                    wx.chooseImage({
                        count: 1, // 默认9
                        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                        sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
                        success: function (res) {
                            var localId = res.localIds[0]; // 返回选定照片的本地 ID 列表，localId可以作为 img 标签的 src 属性显示图片
                            console.log('图片信息', localId)
                            wx.getLocalImgData({
                                localId: localId, // 图片的localID
                                success: function (res) {
                                    var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
                                   console.log('base64=')
                                    resolve(localData)
                                },
                                fail:(err)=>{
                                    console.log('图片转换错误',err)
                                }
                            });
                        },
                        fail:(err)=>{
                            console.log('图片拍照错误',err)
                        }
                    });

                });
                wx.error(function (res) {
                    console.log('jssdk验证失败', res)
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                });
            })
        })
    },

}
